// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_a-2";
export var blackBorderOnHover = "_a-7";
export var cell = "_a-6";
export var cellContainer = "_a-3";
export var checked = "_a-8";
export var disabled = "_a-5";
export var featuredIconCellContainer = "_a-9";
export var featuredIconTextContainer = "_a-b";
export var featuredIconWrapper = "_a-a";
export var noBorder = "_a-c";
export var orangeSelectedRow = "_m-3";
export var overflowableText = "_a-0";
export var overflowableTextContainer = "_a-1";
export var row = "_b-0";
export var rowCheckboxCell = "_a-4";
export var selectableTable = "_m-2";